import { useIntersectionObserver } from "@/hooks";
import styles from "@/styles/InfinityScrollList.module.scss";
import classnames from "classnames";
import { useEffect, useRef, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function InfinityScrollList(_ref) {
  var _observerOpts;
  let {
    loadMore,
    fetchMore,
    observerOpts,
    children
  } = _ref;
  const {
    0: loadingMore,
    1: setLoadingMore
  } = useState(false);
  const loader = useRef();
  // TODO: optionは調整する
  observerOpts = (_observerOpts = observerOpts) !== null && _observerOpts !== void 0 ? _observerOpts : {
    root: null,
    rootMargin: "10px",
    threshold: 0.25
  };
  const intersect = useIntersectionObserver(loader, observerOpts);
  useEffect(() => {
    const func = async () => {
      if (loadMore && intersect && !loadingMore) {
        setLoadingMore(true);
        await fetchMore();
        setLoadingMore(false);
      }
    };
    func();
  }, [loadMore, intersect, loadingMore]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.list,
      children: children
    }), /*#__PURE__*/_jsx("div", {
      ref: loader,
      className: classnames(styles.loader, {
        [styles.show]: loadMore
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.spinner,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.bounce1
        }), /*#__PURE__*/_jsx("div", {
          className: styles.bounce2
        }), /*#__PURE__*/_jsx("div", {
          className: styles.bounce3
        })]
      })
    })]
  });
}